<template>
  <div>
    <CredentialsLoader>
      <AffirmationDialog
        :isOpen="singpassNoticeOpen"
        body="Singaporeans/PRs will need a valid Singpass for registration"
        title="Singpass Validation"
        buttonText="Okay"
        @okay="singpassNoticeOpen = false"
      />
      <div class="home">
        <v-container class="h-full home-container">
          <BackgroundOverlay v-if="isNACCMerchant && isCredentialsLoaded && collections.isLoading"/>
          <CenterLoader v-if="!isNACCMerchant && collections.isLoading" />
          <div v-else class="d-flex flex-column h-full home-wrapper">
            <RedemptionNotification class="text-h1 mt-2 mb-1 flex-grow-0" v-if="isLogin && showNotification" />
            <h1 class="text-h1 mt-3 mb-5 flex-grow-0 ml-2">
              {{ GetCaption("HOME_BROWSE") }}
            </h1>
            <AppTabs class="flex-grow-0"/>
            <Products class="flex-grow-1"/>
          </div>
        </v-container>
      </div>
    </CredentialsLoader>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Options from 'vue-class-component'

import AppTabs from '@/components/AppTabs.vue'
import AffirmationDialog from '@/components/AffirmationDialog.vue'
import CenterLoader from '@/components/CenterLoader.vue'
import Products from '@/components/Products.vue'
import RedemptionNotification from '@/components/RedemptionNotification.vue'
import CredentialsLoader from '@/layout/CredentialsLoader.vue'
import BackgroundOverlay from '@/components/BackgroundOverlay.vue'

import { Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { getPath } from '@/utils/general-utils'
import { GetCaption } from '@/utils/util.language'

const SINGPASS_NOTICE_DELAY_MS = 2000
let hasShownSingpassNotice = false

@Options({
  components: {
    AffirmationDialog,
    AppTabs,
    CenterLoader,
    Products,
    RedemptionNotification,
    CredentialsLoader,
    BackgroundOverlay,
  },
  computed: {
    ...mapGetters([
      'isCredentialsLoaded',
      'isNACCMerchant',
      'heritage_journey',
      'fallbackURL',
      'isGuestLogin',
      'isCulturePassEnable',
    ])
  }
})
export default class Home extends Vue {
  getPath = getPath
  GetCaption = GetCaption
  isNACCMerchant!: boolean
  isCredentialsLoaded!: boolean
  heritage_journey!: boolean
  fallbackURL!: string
  isGuestLogin!: boolean
  isCulturePassEnable!: boolean
  singpassNoticeOpen = false
  singpassNoticeTimer?: ReturnType<typeof setTimeout>

  @Watch('isCredentialsLoaded', { immediate: true })
  onCredentialLoaded(newValue: boolean): void {
    if (newValue) {
      this.$store.dispatch('loadCollections')
      this.scheduleSingpassNotice()
    }
  }

  scheduleSingpassNotice(): void {
    if (this.isCulturePassEnable || hasShownSingpassNotice || this.singpassNoticeTimer) {
      return
    }

    this.singpassNoticeTimer = setTimeout(() => {
      this.singpassNoticeTimer = undefined
      hasShownSingpassNotice = true
      this.singpassNoticeOpen = true
    }, SINGPASS_NOTICE_DELAY_MS)
  }

  mounted(): void | Promise<boolean> {
    if (this.$store.state.auth.token !== undefined && !this.isGuestLogin) {
      return this.$store.dispatch('loadNotification')
    }
  }

  beforeDestroy(): void {
    if (this.singpassNoticeTimer) {
      clearTimeout(this.singpassNoticeTimer)
      this.singpassNoticeTimer = undefined
    }
  }

  created(): void {
    const { path } = this.$route.query

    if (path) {
      if (this.isLogin) {
        if (path === 'browse') {
          this.$router.push(getPath('/'))
        } else if (path === 'tickets') {
          this.$router.push(getPath('/my-tickets'))
        } else {
          this.$router.push(getPath(`/${path}`))
        }
      } else this.$router.push(getPath(`/auth?path=${path}`))
    }
  }

  get collections(): void {
    return this.$store.state.collections
  }

  get isLogin(): boolean {
    return this.$store.state.auth.token !== undefined
  }

  get showNotification(): boolean {
    return this.$store.state.notification?.ticket?.length > 0
  }
}
</script>

<style lang="scss" scoped>
.home {
  min-height: calc(100vh - 153px);
  height: 110%;
}

.home-container {
  min-height: calc(100vh - 153px);
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  max-width: 550px;
}
.home-wrapper {
  margin-left: -4px !important;
}

@media #{map-get($display-breakpoints, "sm-and-up")} {
  .home {
    min-height: calc(100vh - 118px);
    height: 100%;
  }
}

@media #{map-get($display-breakpoints, "md-and-up")} {
  .home-container {
    h1 {
      font-size: 32px !important;
      text-align: center;
      margin: 2rem 0 !important;
    }
  }
}

</style>
